export default 'https://tme.understood.org/assets/global_intro.en.e16a7ae1.vtt'